export default {
    init: function () {
        const parentItems = document.querySelectorAll(".drilldown-root-menu .menu-item-has-children");
        const menuToggleBtn = document.querySelector(".mobile-menu-toggle");
        const closeMenuBtn = document.querySelector(".mobile-menu-close");
        const navMenu = document.getElementById("mobile-drilldown-menu");

        if (menuToggleBtn && navMenu) {
            if (!menuToggleBtn.hasAttribute("data-toggle-init")) {
                menuToggleBtn.setAttribute("data-toggle-init", "true");
                menuToggleBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    navMenu.classList.remove("-translate-y-full");
                    navMenu.classList.add("translate-y-0");
                });
            }
        }

        if (closeMenuBtn && navMenu) {
            if (!closeMenuBtn.hasAttribute("data-close-init")) {
                closeMenuBtn.setAttribute("data-close-init", "true");
                closeMenuBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    navMenu.classList.remove("translate-y-0");
                    navMenu.classList.add("-translate-y-full");
                });
            }
        }

        parentItems.forEach((item) => {
            if (item.hasAttribute("data-menu-init")) return;
            item.setAttribute("data-menu-init", "true");

            const link = item.querySelector(":scope > a");
            const submenu = item.querySelector(":scope > .sub-menu");

            if (!link || !submenu) {
                return;
            }
            const arrowSpan = document.createElement("span");
            arrowSpan.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg>`;
            link.appendChild(arrowSpan);

            const backListItem = document.createElement("li");
            const parentTitle = link.textContent.trim();

            backListItem.innerHTML = `
                    <button class="drilldown-back-btn text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
                        Wróć do: ${parentTitle}
                    </button>
                `;

            submenu.insertBefore(backListItem, submenu.firstChild);

            link.addEventListener("click", (e) => {
                e.preventDefault();
                submenu.classList.add("is-active");
            });

            const backBtn = backListItem.querySelector("button");
            backBtn.addEventListener("click", (e) => {
                e.preventDefault();
                submenu.classList.remove("is-active");
            });
        });
    },
};
